var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.553 19.993c-.378-1.896 1.299-3.825 3.746-4.31 1.376-.273 2.703-.03 3.668.57V4.311c0-.374.264-.744.636-.818l11.15-2.228c.51-.103.917.34.917.826V16.59s.24 2.94-3.8 3.738c-2.447.485-4.738-.659-5.117-2.555-.378-1.896 1.299-3.825 3.746-4.31 1.378-.273 2.706-.03 3.671.573V2.91l-9.703 1.94v13.96s.241 2.938-3.796 3.738c-2.448.485-4.739-.659-5.118-2.555zm4.038-2.839c2.006-.397 3.203.62 3.355 1.377.15.755-.56 2.148-2.567 2.546-2.006.397-3.203-.62-3.355-1.378-.15-.754.56-2.148 2.567-2.545zm11.988 1.703c2.006-.398 2.717-1.79 2.567-2.546-.152-.758-1.349-1.774-3.355-1.377-2.006.397-2.717 1.79-2.567 2.546.152.758 1.349 1.774 3.355 1.377z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/Music.748b2e283efb1430b6a98727af1d93c9.svg";
export { ForwardRef as ReactComponent };